import { Debt } from '../models/Entities/CashFlow/Debt/Debt';
import { NewDebt } from '../models/Entities/CashFlow/Debt/NewDebt';
import { apiRequest, buildURL } from './commons/CommonService.Functions';

// urls
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'cashflow/debts';

// Get all debts by creditor
export const GetDebtsByCreditor = async (token: string, creditorIdentifier: string, debitorIdentifier: string | undefined): Promise<Debt[]> => {
    let RequestCreditorURL: string = BaseURL + '/creditor/' + creditorIdentifier;

    if (debitorIdentifier) {
        RequestCreditorURL += '?DebtorId=' + debitorIdentifier;
    }

    return apiRequest<Debt[]>(RequestCreditorURL, token, 'GetDebtsByCreditor');
};

// Get all debts by debtor
export const GetDebtsByDebtor = async (token: string, debtorIdentifier: string, creditorIdentifier: string | undefined): Promise<Debt[]> => {
    let RequestDebtorURL: string = BaseURL + '/debtor/' + debtorIdentifier;
    
    if (creditorIdentifier) {
        RequestDebtorURL += '?CreditorId=' + creditorIdentifier;
    }

    return apiRequest<Debt[]>(RequestDebtorURL, token, 'GetDebtsByDebtor');
};

// Get debt by id
export const GetDebtById = async (token: string, debtId: number): Promise<Debt> => {
    const RequestURL: string = buildURL(BaseURL, debtId);
    return apiRequest<Debt>(RequestURL, token, 'GetDebtById');
};

// Create debt
export const CreateDebt = async (token: string, debt: NewDebt): Promise<Debt> => {
    return apiRequest<Debt>(BaseURL, token, 'CreateDebt', {
        method: 'POST',
        body: JSON.stringify(debt)
    });
};

// update debt
export const UpdateDebt = async (token: string, debt: Debt): Promise<Debt> => {
    const RequestURL: string = buildURL(BaseURL, debt.id);
    return apiRequest<Debt>(RequestURL, token, 'UpdateDebt', {
        method: 'PUT',
        body: JSON.stringify(debt)
    });
};

// delete debt
export const DeleteDebt = async (token: string, debtId: number): Promise<boolean> => {
    const RequestURL: string = buildURL(BaseURL, debtId);
    return apiRequest<boolean>(RequestURL, token, 'DeleteDebt', {
        method: 'DELETE'
    });
};

// Get debts by settlement id
export const GetDebtsBySettlementId = async (token: string, settlementId: number, currencyCode?: string, onlyActive: boolean = true): Promise<Debt[]> => {
    let RequestURL: string = buildURL(BaseURL, 'settlements', settlementId);
    
    const params = new URLSearchParams();
    if (currencyCode) {
        params.append('currencyCode', currencyCode);
    }
    params.append('OnlyActive', onlyActive.toString());
    
    if (params.toString()) {
        RequestURL += '?' + params.toString();
    }

    return apiRequest<Debt[]>(RequestURL, token, 'GetDebtsBySettlementId');
};

// Check if a debt is fully paid (no pending amount)
export const CheckDebtPaid = async (token: string, debtId: number): Promise<boolean> => {
    const RequestURL: string = buildURL(BaseURL, debtId, 'paid');
    return apiRequest<boolean>(RequestURL, token, 'CheckDebtPaid');
};

// Check debt payment status and dispatch domain events (OnDebtGetPaid / OnDebtGetUnpaid)
export const CheckDebtStatus = async (token: string, debtId: number): Promise<boolean> => {
    const RequestURL: string = buildURL(BaseURL, debtId, 'check-status');
    return apiRequest<boolean>(RequestURL, token, 'CheckDebtStatus', { method: 'POST' });
};